import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import SignOut from '../pages/SignOut';
import BarberShop from '../pages/BarberShop';
import ConfirmAppointment from '../pages/ConfirmAppointment';
import { Home } from '../pages/Home';
import { Income } from '../pages/Income';
import { Services } from '../pages/Services';
import { Schedules } from '../pages/Schedules';
import AppointmentPage from '../pages/AppointmentPage';
import SignUpCompany from '../pages/SignUpCompany';
import SignUpPlan from '../pages/SignUpPlan';
import RecoverPassword from '../pages/RecoverPasssword';
import Company from '../pages/Company';
import DeleteAppointment from '../pages/DeleteAppointment';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route exact path="/parceiro/:slug" component={BarberShop} />
      <Route
        exact
        path="/parceiro/:slug/confirmacao"
        component={ConfirmAppointment}
      />
      <Route
        exact
        path="/parceiro/:slug/agendamento"
        component={AppointmentPage}
      />
      <Route
        exact
        path="/parceiro/:slug/agendamento/:id/excluir"
        component={DeleteAppointment}
      />

      <Route path="/cadastro/negocio" component={SignUpCompany} />
      <Route path="/cadastro/planos" component={SignUpPlan} />
      <Route path="/cadastro" component={SignUp} />
      <Route path="/recuperar-senha" component={RecoverPassword} />
      <Route path="/dashboard" component={Home} isPrivate />
      <Route path="/graficos" component={Income} isPrivate />
      <Route path="/servicos" component={Services} isPrivate />
      <Route path="/horarios" component={Schedules} isPrivate />
      <Route path="/negocio" component={Company} isPrivate />

      <Route path="/signout" component={SignOut} isPrivate />
    </Switch>
  );
};

export default Routes;
